import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(`w100 TemplateForAiEditContent`),
  style: {}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fw600 fs14 pad10 dblue" }, "マニュアル例", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  class: "fs14 ml10 fw600 fl",
  style: {"margin-bottom":"0"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    (_ctx.typeArray)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeArray, (fieldName, fieldindex) => {
            return (_openBlock(), _createElementBlock("li", {
              key: fieldindex,
              onClick: ($event: any) => (_ctx.clickField(fieldName)),
              class: "pointer pad10",
              style: {"border":"1px solid #eee"}
            }, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(fieldName), 1),
              _hoisted_6
            ], 8, _hoisted_4))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _hoisted_7,
    _hoisted_8,
    _hoisted_9
  ]))
}